import { useBoundaryClock } from "./useBoundaryClock";

/**
 * How long before an event starts its attendees switch from getting ready
 * (Sparking who's going) to getting there: the /events widget shows the map,
 * and the event page shows the check-in code at full size.
 */
export const EVENT_SOON_HOURS = 6;
const EVENT_SOON_MS = EVENT_SOON_HOURS * 60 * 60 * 1000;

/** When the EVENT_SOON_HOURS window opens for an event, in epoch ms. */
export const eventSoonAt = (startsAt: string) =>
  new Date(startsAt).getTime() - EVENT_SOON_MS;

export const isEventSoon = (startsAt: string | null | undefined, now = Date.now()) =>
  !!startsAt && now >= eventSoonAt(startsAt);

/**
 * Whether the event starts within EVENT_SOON_HOURS (or has started). Flips by
 * itself when the window opens, so a page left open turns over on time.
 */
export const useIsEventSoon = (startsAt: string | null | undefined) => {
  const now = useBoundaryClock(startsAt ? [eventSoonAt(startsAt)] : []);
  return isEventSoon(startsAt, now);
};
